import React, { useState, useEffect } from 'react';
import { useQuery } from '@apollo/client';
import { useDocumentState } from '../../../../../../../contexts/DocumentContext';

import ReviewViaEmailSlideout from './ReviewViaEmailSlideout';

import PlaceholderWarningModal from '../../../../../document-wizard-modal/custom-modals/placeholderWarningModal/placeholderWarningModal';
import { queriesV2 } from '../../../../../../../api';

type ReviewViaEmailModalContainerProps = {
  isOpen: boolean;
  onClose: () => void;
  teamId: string;
  dealId: string;
  placeholdersToComplete?: number;
};

const ReviewViaEmailModalContainer = ({
  isOpen,
  onClose,
  teamId,
  dealId,
  placeholdersToComplete = 0,
}: ReviewViaEmailModalContainerProps) => {
  const hasRequiredPlaceholders = placeholdersToComplete !== 0;

  const [showWarningModal, setShowWarningModal] = useState(isOpen && hasRequiredPlaceholders);

  const [showModal, setShowModal] = useState(isOpen && !hasRequiredPlaceholders);

  const { state } = useDocumentState();
  const documentId = state.id;

  // Get document editor configuration to check if Word export is disabled
  const { data: documentData } = useQuery(queriesV2.getDocumentById, {
    variables: { documentId: documentId! },
    skip: !documentId,
  });

  // Get document extra attachments for checkbox selection
  const { data: attachmentsData } = useQuery(queriesV2.getDocumentExtraAttachments, {
    variables: { documentId: documentId! },
    skip: !documentId,
  });

  // Extract disable_word_export from document's editor configuration
  const disableWordExport = documentData?.getDocumentById?.editorConfiguration?.disable_word_export || false;

  // Extract document source to determine if it's an imported PDF
  const documentSource = documentData?.getDocumentById?.source;

  // Extract extra attachments
  const extraAttachments = attachmentsData?.getDocumentById?.extraAttachments || [];

  const handleWarningModalClose = () => {
    setShowWarningModal(false);
    setShowModal(false);
    onClose();
  };

  useEffect(() => {
    setShowWarningModal(isOpen && hasRequiredPlaceholders);

    setShowModal(isOpen && !hasRequiredPlaceholders);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen]);

  return (
    <>
      <ReviewViaEmailSlideout
        isOpen={showModal}
        onClose={onClose}
        teamId={teamId}
        dealId={dealId}
        enableAttachments={true}
        disableWordExport={disableWordExport}
        extraAttachments={extraAttachments}
        documentSource={documentSource}
      />
      <PlaceholderWarningModal
        isOpen={showWarningModal}
        placeholders={placeholdersToComplete}
        onContinue={() => {
          setShowWarningModal(false);
          // Delay slideout opening to ensure warning modal closes first
          setTimeout(() => {
            setShowModal(true);
          }, 100);
        }}
        onReview={handleWarningModalClose}
        onHide={handleWarningModalClose}
      />
    </>
  );
};

export default ReviewViaEmailModalContainer;
